module.exports = __webpack_public_path__ + "img/xlsx.fc83e4e8.svg";